(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/collections/outcomes.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/collections/outcomes.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.collections = svs.matchen.collections || {};

  svs.matchen.collections.Outcomes = Backbone.Collection.extend({
    MAX_NUMBER_OF_SELECTED_ALLOWED: 10,

    initialize: function() {
      this.listenTo(this, 'change', this.checkNumberOfSelected);
    },

    checkNumberOfSelected: function(model) {
      if (model && model.changed && _.has(model.changed, 'selected')) {
        var previousNumberOfSelected = this.numberOfSelected;
        this.numberOfSelected = this.getNumberOfOutcomesSelected();

        if (this.numberOfSelected == this.MAX_NUMBER_OF_SELECTED_ALLOWED) {
          this.invoke('set', { unselectedDisabled: true });
        } else if (
          previousNumberOfSelected == this.MAX_NUMBER_OF_SELECTED_ALLOWED &&
          this.numberOfSelected < this.MAX_NUMBER_OF_SELECTED_ALLOWED
        ) {
          this.invoke('set', { unselectedDisabled: false });
        }
      }
    },

    deselectAll: function() {
      this.invoke('set', { selected: false });
    },

    isAnySelected: function() {
      return this.findWhere({ selected: true }) !== undefined;
    },

    getNumberOfOutcomesSelected: function() {
      return this.getSelectedOutcomes().length;
    },

    getSelectedOutcomes: function() {
      return this.where({ selected: true });
    },

    setSelectedOutcomes: function(outcomes) {
      _.each(
        outcomes,
        function(outcome) {
          _.find(this.models, function(model) {
            return model.get('outcome') === outcome.outcome;
          }).set('selected', true);
        },
        this
      );
    },

    getSelectedOutcomesAsArray: function(options) {
      options = _.defaults({}, options, { asStrings: false });

      var outcome;

      return _.reduce(
        this.models,
        function(memo, model) {
          if (model.get('selected')) {
            outcome = model.get('outcome');

            if (!_.isString(outcome) && options.asStrings) {
              outcome = String(outcome);
            }

            memo.push(outcome);
          }

          return memo;
        },
        []
      );
    },

    setHeatmapValues: function() {
      var heatmapStartMin = svs.matchen.app.config.getHeatmapStartMin();
      var heatmapStartMax = svs.matchen.app.config.getHeatmapStartMax();
      var heatmapMin = svs.matchen.app.config.getMinOutcomeValue();
      var heatmapMax = svs.matchen.app.config.getMaxOutcomeValue();

      _.each(this.models, function(model) {
        if (
          model.get('outcome') < heatmapStartMin ||
          model.get('outcome') > heatmapStartMax
        ) {
          model.set('hidden', true);
        }
      });

      this.hasHeatmapExpandUp = heatmapStartMin > heatmapMin;
      this.hasHeatmapExpandDown = heatmapStartMax < heatmapMax;
    },

    toggleTopHeatmap: function(hidden) {
      var min =
        svs.matchen.app.config.getHeatmapStartMin() -
        svs.matchen.app.config.getMinOutcomeValue();

      for (var i = 0; i < min; i++) {
        this.models[i].set('hidden', hidden);
      }
    },

    toggleBottomHeatmap: function(hidden) {
      var max =
        svs.matchen.app.config.getHeatmapStartMax() -
        svs.matchen.app.config.getMinOutcomeValue() +
        1;

      for (var i = max; i < this.models.length; i++) {
        this.models[i].set('hidden', hidden);
      }
    },

    collapseHeatMap: function() {
      this.toggleTopHeatmap(true);
      this.toggleBottomHeatmap(true);
    },

    setMaxPercent: function(maxPercent) {
      this.maxPercent = maxPercent;
    }
  });
})(Backbone, _, svs);


 })(window);